"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/* eslint-disable flowtype/require-return-type */
var _default = function _default(theme) {
  return {
    Root: {
      '& .active': {
        background: theme['$background-color'],
        cursor: 'default',
        color: theme['$text-color']
      }
    },
    Section: {
      cursor: 'pointer',
      height: 43,
      padding: [20, 3, 20, 20],
      display: 'flex',
      position: 'relative',
      '& .icon-container': {
        width: 20,
        fontSize: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        marginLeft: 1
      },
      '& .title': {
        lineHeight: '14px',
        fontWeight: 500,
        marginBottom: 3
      },
      '&:not(.active)': {
        color: theme['$link-color']
      },
      '& .subtitle': {
        fontSize: 11,
        lineHeight: '13px',
        width: 153,
        color: theme['$text-color']
      }
    },
    DisabledSection: {
      cursor: 'default',
      '& .section-content': {
        opacity: 0.3
      }
    },
    DisabledPill: {
      position: 'absolute',
      top: 10,
      right: 10,
      fontSize: 10,
      fontWeight: 'bold',
      lineHeight: '17px'
    },
    Tag: {
      position: 'absolute',
      top: 10,
      right: 10
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=VerticalMenu.style.js.map